import moment from 'moment'
import api from '../../../services/service'

export default {
  data () {
    return {
      nowDate: moment(new Date()),
      header: {
        'Access-Token': this.$store.state.token
      },
      data_detail: {
        'company_name': '',
        'create_by': '',
        'create_time': '',
        'edit_by': '',
        'edit_time': '',
        'tax_id': '',
        'tax_rate': 7,
        'text_show_1': '',
        'text_show_2': '',
        'text_show_3': '',
        'text_show_4': '',
        'text_show_5': '',
        'text_show_6': ''
      }
    }
  },
  methods: {
    getConfigCompany () {
      this.$store.commit('Loading')
      api.companyDetail(
        this.REST_URL,
        this.header,
        result => {
          if (result.response === 'success') {
            this.data_detail = result.data[0]
          } else {
            this.$notification['success']({
              message: 'ดึงข้อมูลบริษัท',
              description: result.message
            })
          }
          this.$store.commit('Loading')
        },
        error => {
          this.$store.commit('Loading')
          alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
        }
      )
    },
    editConfigCompany () {
      this.$store.commit('Loading')
      this.data_detail.id = parseInt(this.data_detail.id)
      // this.data_detail.company_id = parseInt(this.data_detail.company_id)
      this.data_detail.tax_rate = parseInt(this.data_detail.tax_rate)
      console.log(JSON.stringify(this.data_detail))
      api.companyUpdate(
        this.REST_URL,
        this.header,
        this.data_detail,
        result => {
          if (result.response === 'success') {
            this.getConfigCompany()
            this.$notification['success']({
              message: 'อัพเดทข้อมูลบริษัทเรียบร้อย'
            })
          } else {
            this.$notification['success']({
              message: 'อัพเดทข้อมูลบริษัท',
              description:
                      result.message
            })
          }
          this.$store.commit('Loading')
        },
        error => {
          this.$store.commit('Loading')
          alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
        }
      )
    }
  },
  mounted () {
    this.getConfigCompany()
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/settings/company.js